export const invitationModal = ["Invite by email"];
